var _mask, _mask2, _circle, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCircleLimeLeaf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "icon-circle-lime--leaf_svg__a",
    height: 37,
    maskUnits: "userSpaceOnUse",
    width: 37,
    x: 6,
    y: 7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 7h37v37H6z",
    fill: "#d9d9d9"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "icon-circle-lime--leaf_svg__b",
    height: 40,
    maskUnits: "userSpaceOnUse",
    width: 41,
    x: 5,
    y: 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.03 5h40v40h-40z",
    fill: "#d9d9d9"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    fill: "#e3fb94",
    r: 25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-circle-lime--leaf_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-circle-lime--leaf_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14.8 28.372c2.044-6.078 7.754-10.838 14.335-10.838-8.652 2.259-13.79 9.854-13.79 18.466h2.758s-.42-2.612.309-5.616c5.84.783 8.791.323 11.483-5.413 1.067-2.275 2.276-4.852 5.789-6.843a.682.682 0 00.074-1.139c-8.23-6.153-25.576-3.02-20.958 11.383z",
    fill: "#000",
    fillRule: "evenodd"
  })))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle-lime--leaf-9f09ce7da00791637ed7c81db0946cba.svg";
export { SvgIconCircleLimeLeaf as Component };